import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {SalarieDto} from "./dto/salarie.dto";
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {PageResponse} from "../../../shared/data-access/http/dto/page-dto";

@Injectable({providedIn:'root'})
export class SalarieHttp {
  private static readonly endpoint = environment.baseUrl + '/salaries'
  private readonly http = inject(HttpClient)

  findSalariesByKeyword(keyword: string, codeChantier:string): Observable<PageResponse<SalarieDto>> {
    const params = new HttpParams()
      .set('keyword', keyword)
      .set('codeChantier', codeChantier)
      .set('page', 0)
      .set('size', 10)
    return this.http.get<PageResponse<SalarieDto>>(SalarieHttp.endpoint + '/find', {params})
  }
}
